export default __webpack_public_path__ + "static/media/dente.c73113f0.png";